import { render, staticRenderFns } from "./FreeGoods.vue?vue&type=template&id=73e25735&scoped=true&"
import script from "./FreeGoods.vue?vue&type=script&lang=js&"
export * from "./FreeGoods.vue?vue&type=script&lang=js&"
import style0 from "./FreeGoods.vue?vue&type=style&index=0&id=73e25735&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e25735",
  null
  
)

export default component.exports